module.exports = __webpack_public_path__ + "static/media/gh2.21c75d2b.png";